/** Human-readable labels for `WalletTransaction.type` (API enum values unchanged). */

/**
 * @param {string} type - WalletTransaction.type from API
 * @param {object} [txn] - Optional full row (`note`, `direction`) for context-specific labels
 */
export function walletTransactionTypeLabel(type, txn = null) {
  const row = txn && typeof txn === "object" ? txn : {};
  const note = String(row.note ?? "");
  const dir = String(row.direction ?? "").toUpperCase();

  const raw = String(type ?? "").trim();
  if (!raw) return "—";
  const u = raw.toUpperCase();

  // Secondary NAV-locked transfer: product language — share-offer receiver’s wallet leg is shown as "Received"
  // even though the movement is a DEBIT (payment to seller); Direction column still reflects CREDIT/DEBIT.
  if (u === "TRANSFER" && note.includes("Secondary transfer — payment for shares")) {
    return "Received";
  }
  if (u === "TRANSFER" && note.includes("Secondary transfer — sale proceeds")) {
    return "Received";
  }

  if (u === "INVESTMENT") return "Share purchased";
  if (u === "DEPOSIT") return "Deposit";
  if (u === "WITHDRAWAL") return "Withdrawal";
  if (u === "REFUND") return "Redeem Shares";
  if (u === "ADJUSTMENT") return "Adjustment";
  if (u === "POINTS_REDEMPTION") return "Points redemption";
  if (u === "TRANSFER") {
    if (dir === "CREDIT") return "Received";
    if (dir === "DEBIT") return "Sent";
    return "Transfer";
  }
  return raw;
}
